import * as DialogRadix from '@radix-ui/react-dialog';
import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';

import './dialog.scss';
import { CrossIcon } from '../Icon';

interface Props extends PropsWithChildren {
  title: string;
  description?: string;
  content: ReactNode;
  footer?: ReactNode;
  open?: boolean;
  className?: string;
  onOpenChange?: (open: boolean) => void;
}

export const Dialog = ({
  title,
  description,
  content,
  children,
  footer,
  open,
  onOpenChange,
  className = '',
}: Props) => {
  return (
    <DialogRadix.Root open={open} onOpenChange={onOpenChange}>
      <DialogRadix.Trigger className="payflow-ui-dialog__trigger">{children}</DialogRadix.Trigger>
      <DialogRadix.Portal>
        <DialogRadix.Overlay className="payflow-ui-dialog__overlay" />
        <DialogRadix.Content className={classNames('payflow-ui-dialog__content', className)}>
          <div className="payflow-ui-dialog__header">
            <DialogRadix.Title className="payflow-ui-dialog__title">{title}</DialogRadix.Title>
            <DialogRadix.Close asChild>
              <button className="payflow-ui-dialog__icon-button" aria-label="Close">
                <CrossIcon />
              </button>
            </DialogRadix.Close>
          </div>

          <div className="payflow-ui-dialog__body">
            <DialogRadix.Description className="payflow-ui-dialog__description">{description}</DialogRadix.Description>
            {content}
          </div>

          <div className="payflow-ui-dialog__footer">{footer}</div>
        </DialogRadix.Content>
      </DialogRadix.Portal>
    </DialogRadix.Root>
  );
};
